function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownloadPortal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 23"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 6.21v1h4V22H1V7h4V6H0v17h17V6.21z",
  style: {
    fill: "#262626"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 13.39V0h1v13.39l2.33-2.33.71.71-3.54 3.54-3.54-3.54.71-.71z",
  style: {
    fill: "#262626"
  }
}));
export default SvgDownloadPortal;